import React from 'react';
import { useTranslation } from '../../context/LanguageContext';

const CheckboxField = ({ label, checked, onChange, className = '' }) => {
    const { isRTL } = useTranslation();
    return (
        <div className={`${className}`}>
            <div className="flex items-center justify-start">
                <div className={`flex items-center ${isRTL ? 'flex-row-reverse' : 'flex-row'}`} style={{ direction: 'ltr' }}>
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={onChange}
                        className={`w-5 h-5 border-2 border-gray-300 rounded-md text-yellow-500 focus:ring-yellow-500 focus:ring-offset-0 transition-all duration-200 ${isRTL ? 'mr-0 ml-4' : 'ml-0 mr-4'}`}
                    />
                    <label className={`text-sm font-medium text-gray-700 select-none cursor-pointer ${isRTL ? 'text-right' : 'text-left'}`} style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
                        {label}
                    </label>
                </div>
            </div>
        </div>
    );
};

export default CheckboxField;
